import Home from '@/pages/Home.vue'
import Login from '@/pages/Login.vue'
import Dashboard from '@/pages/Dashboard.vue'
import dianpu from '@/pages/dianpu/index.vue'
import AdverType from '@/pages/advert/AdverType.vue'
import Adver from '@/pages/advert/Adver.vue'
import Slide from '@/pages/advert/Slide.vue'
import ZhuanTi from '@/pages/advert/ZhuanTi.vue'
import Brand from '@/pages/goods/Brand.vue'
import kuaidimoban from '@/pages/kuaidi/moban.vue'
import kuaidirule from '@/pages/kuaidi/rule.vue'
import GoodsList from '@/pages/goods/List.vue'
import FirstMenu from '@/pages/goods/FirstMenu.vue'
import SecMenu from '@/pages/goods/SecMenu.vue'
import CouponCode from '@/pages/activity/CouponCode.vue'
import Festival from '@/pages/activity/Festival.vue'
import Comment from '@/pages/goods/Comment.vue'
import OrderList from '@/pages/order/List.vue'
import UserList from '@/pages/user/List.vue'
import Pets from '@/pages/user/Pets.vue'
import User from '@/pages/system/User.vue'
import Images from '@/pages/system/Images.vue'
import Specification from '@/pages/goods/Specification.vue'
import ProSpecification from '@/pages/goods/ProSpecification.vue'
import Tixian from '@/pages/user/Tixian.vue'
import KaquanList from '@/pages/kaquan/List.vue'
import KaquanRecord from '@/pages/kaquan/Record.vue'
import Keyword from '@/pages/system/Keywords.vue'
import Chaidan from '@/pages/order/Chaidan.vue'
import orderlist1 from '@/pages/order/list1.vue'
import indexcategory from '@/pages/goods/indexcategory.vue'
import Kucun from '@/pages/goods/Kucun.vue'
import movingpin from '@/pages/goods/movingpin.vue'
import spider from '@/pages/system/spider.vue'
import shopcar from '@/pages/goods/shopcar.vue'
let routes = [
  {
    path: '/login',
    component: Login,
    hidden: true
  },
  {
    path: '/',
    component: Home,
    name: '首页',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/', component: Dashboard, name: '首页' }
    ]
  },
   {
    path: '/',
    component: Home,
    name: '店铺管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/dianpu', component: dianpu, name: '店铺管理' }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '广告管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/adver', component: Adver, name: '广告' },
      { path: '/zhuanti', component: ZhuanTi, name: '专题' },
      { path: '/advert/advertype', component: AdverType, name: '场景' },
      { path: '/slide/:id', component: Slide, name: '幻灯片', hidden: true }
    ]
  },

  {
    path: '/',
    component: Home,
    name: '商品管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [

      { path: '/goods/brand', component: Brand, name: '品牌' },
      { path: '/goods/indexcategory', component: indexcategory, name: '首页分类' },
      { path: '/goods/firstmenu', component: FirstMenu, name: '一级分类' },
      { path: '/goods/secmenu', component: SecMenu, name: '二级分类' },
      { path: '/goods/specification', component: Specification, name: '商品规格' },
      { path: '/goods/prospec/:proid', component: ProSpecification, name: '商品规格', hidden: true },
      { path: '/goods/list', component: GoodsList, name: '商品信息' }
    ]
  },
   {
    path: '/',
    component: Home,
    name: '数据管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
         { path: '/shopcar', component: shopcar, name: '购物车' },
          { path: '/goods/movingpin', component: movingpin, name: '商品罗盘' },
          { path: '/goods/Kucun', component: Kucun, name: '库存警告' }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '订单管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/order/list', component: OrderList, name: '订单列表' },
      { path: '/order/list1', component: orderlist1, name: '退货订单' },
      { path: '/order/list/:usid', component: OrderList, name: '订单列表', hidden: true },
      { path: '/order/list/:usid/:orderNum', component: OrderList, name: '订单列表', hidden: true },
      { path: '/order/chaidan/:orderNum', component: Chaidan, name: '订单列表', hidden: true }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '活动管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/activity/code', component: CouponCode, name: '优惠码' }
    ]
  },
 {
    path: '/',
    component: Home,
    name: '快递管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/kuaidi/moban', component: kuaidimoban, name: '快递模板' },
      { path: '/kuaidi/rule', component: kuaidirule, name: '快递规则' }
    ]
  },

  {
    path: '/',
    component: Home,
    name: '用户管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      { path: '/user/info', component: UserList, name: '用户列表' },
      { path: '/user/info/:usid', component: UserList, name: '用户列表', hidden: true },
      { path: '/tixian', component: Tixian, name: '提现列表' }
      // { path: '/user/pets', component: Pets, name: '宠物' }
    ]
  },
  {
    path: '/',
    component: Home,
    name: '系统管理',
    iconCls: 'fa fa-address-card',
    leaf: false,
    children: [
      // { path: '/system/images', component: Images, name: '图片管理' },
      { path: '/system/user', component: User, name: '后台用户' },
      { path: '/keywords', component: Keyword, name: '关键词' },
      { path: '/spider', component: spider, name: '爬虫库' }
    ]
  }
];
export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js